import React from "react";
import { Link } from "react-router-dom";
import "./revamp.css";

const notFoundIllustration = "https://d1vqw4it8x9uac.cloudfront.net/admin/house-restyling-bro-1-1790236892.png";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "For professionals", to: "/professionals" },
  { label: "Post a requirement", to: "/enquiry" },
  { label: "Contact us", to: "/contact" },
];

function NotFoundPage() {
  return (
    <div className="revamp-page revamp-page-with-footer revamp-not-found-page">
      <main className="revamp-not-found-main">
        <div className="revamp-section-shell revamp-not-found-shell">
          <div className="revamp-not-found-card" role="alert" aria-live="polite">
            <p className="revamp-not-found-watermark" aria-hidden="true">
              404
            </p>

            <div className="revamp-not-found-visual" aria-hidden="true">
              <img
                src={notFoundIllustration}
                alt=""
                className="revamp-not-found-illustration"
              />
            </div>

            <div className="revamp-not-found-content">
              <p className="revamp-not-found-eyebrow">Page not found</p>
              <h1 className="revamp-not-found-title">
                We couldn&apos;t find
                <span className="revamp-not-found-title-accent"> that page</span>
              </h1>
              <p className="revamp-not-found-copy">
                The link may be broken, outdated, or typed incorrectly. Head back
                home or tell us what you need — we&apos;ll get you to the right place.
              </p>

              <div className="revamp-not-found-actions">
                <Link to="/" className="revamp-not-found-primary-btn">
                  Go to homepage
                </Link>
                {/* <Link to="/enquiry" className="revamp-not-found-secondary-btn">
                  Post a requirement
                </Link> */}
              </div>

              <nav className="revamp-not-found-quick" aria-label="Helpful links">
                <span className="revamp-not-found-quick-label">Popular pages</span>
                <ul className="revamp-not-found-quick-list">
                  {QUICK_LINKS.map(({ label, to }) => (
                    <li key={to}>
                      <Link to={to} className="revamp-not-found-quick-link">
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default NotFoundPage;
